import React, { useEffect } from 'react';
import { ModuleBridge } from '../components';
import { ViewMigrationsTopBar } from '../components/ViewMigrationsTopBar';

export const MigrationList = () => {
    useEffect(() => {
        return () => {
            if (window?.clearMigrationStateCheckPoling) {
                window?.clearMigrationStateCheckPoling();
            }
            if (window?.clearMigrationRefreshStateCheckPoling) {
                window?.clearMigrationRefreshStateCheckPoling();
            }
        };
    }, []);

    return (
        <>
            <ViewMigrationsTopBar />
            <div id="migrations_list_container"></div>
            <ModuleBridge moduleId="migration_list_main" />
        </>
    );
};
